<template>
  <div class="layout">
    <a class="logo-container" href="https://joinfightcamp.com/?utm_source=2019WithABang">
      <img class="logo" src="@/assets/fightcamp-full.svg" />
      <span class="logo-challenge"> Challenge</span>
    </a>

    <section class="section">
      <div class="logo-layout">
        <div class="title-container">
          <h1 class="title1"> START 2019 </h1>
          <span class="title2"> WITH A</span>
          <h1 class="title3"> BANG</h1>
        </div>
      </div>
      <p class="text">
        We’re challenging the FightCamp Community to collectively throw 1 MILLION PUNCHES through the first week of 2019 and it’s
        all for a great cause. If we break 1M punches, FightCamp will donate $5,000 to a youth boxing program in Boston called
        Fit Students for Life. And that’s not all! For every 100,000 punches we throw over 1M, FightCamp will donate an additional
        $1,000 to the program (up to $10,000).
      </p>
    </section>
        <section class="metric-section">
      <PunchCount class="metric-punchcount" :count="total_punch_count" />
    </section>
    <section class="metric-section">
      <Countdown class="metric-countdown" :startdate="start_date" />
    </section>

    <section class="info-container">
      <div class="info-block">
        <h2> About
          <strong> Fit Students for Life </strong>
        </h2>
        <p class="info-text"> Fit Students for Life program is run out of Boston Boxing and awards free gym memberships and training gear to low-income,
          at-risk youth in the Boston area. The students learn boxing and the importance of physical fitness while gaining
          discipline in a structured environment that doubles as a safe haven</p>
        <a href="http://www.bostonboxing.com/charities.html" target="_blank" class="button"> Visit Website </a>

      </div>
      <div class="info-block">

        <h2> About
          <img class="info-logo" src="@/assets/fightcamp-letter.svg" />
        </h2>
        <p class="info-text"> FightCamp puts the best elements of a world class boxing gym directly into your home. Powerful and motivating workouts,
          expert-led instruction and elite trainers combined with premium equipment and the same training tech used by the
          pros.
        </p>
        <a href="https://joinfightcamp.com/?utm_source=2019WithABang" class="button"> Visit Website </a>
      </div>

    </section>
    <Tables :tops="tops" :recents="recents" />
    <a class="link" href="https://joinfightcamp.com/pages/privacy-policy">Privacy Policy</a>
    <a class="link" href="https://joinfightcamp.com/pages/legal-terms">Legal Terms</a>

    <p class="copyright"> © FightCamp 2017-2019, Hykso, Inc. All rights reserved.</p>

  </div>
</template>

<script>
  const API_URL = process.env.VUE_APP_API_URL;
  import axios from 'axios'
  import VueMixinTween from 'vue-mixin-tween';

  import Countdown from './CountDown.vue';
  import Tables from './Tables.vue';
  import PunchCount from './PunchCount.vue';

  //const start_date = 1545033600;
  //const start_date = 1545638400;
  const start_date = 1546329600 // 1er janvier
  export default {
    name: 'LiveDisplay',
    props: {
      msg: String
    },
    components: {
      Countdown,
      Tables,
      PunchCount
    },
    mixins: [
      // The only required argument is the name of the property to tween.
      // The default duration is 500 milliseconds.
      // The default timing function is TWEEN.Easing.Quadratic.Out
      // We're using a "custom" linear timing function here.
      VueMixinTween('total_punch_count', 2000, (pos) => pos)
    ],

    data() {
      return {

        query: "?start=" + start_date,
        data: null,
        tops: [],
        recents: [],
        start_date: start_date,
        metrics: [{
            id: "total_user",
            title: "Users",
          },
          {
            id: "total_session",
            title: "Workouts"
          },
          {
            id: "total_round",
            title: "Rounds"
          },
          {
            id: "total_output",

            title: "Total Output"
          }
        ],
        countdown: {

        },
        countdown_string: "",
        total_punch_count: 0,
      }
    },

    methods: {
      getMetric(id) {
        if (!this.data) {
          return "--"
        }
        return this.data[id];
      },

      retrieveData() {
        // eslint-disable-next-line 
        axios(API_URL + "/challenges/1000").then(resp => {
          this.data = resp.data;
          this.data.total_output = this.data.total_output / 100;
          this.total_punch_count = parseInt(this.data.total_punch_count);     
          //this.total_punch_count = 1623500;


          // eslint-disable-next-line 
          //console.log(this.data);
        })
        axios(API_URL + "/challenges/1000/tops" + this.query).then(resp => {
          this.tops = this.tops.items.splice(this.tops.length);
          this.tops = this.tops.items.concat(resp.data);
          // eslint-disable-next-line 
          //console.log(this.tops)
        })
        axios(API_URL + "/challenges/1000/recents" + this.query).then(resp => {
          this.recents = this.recents.items.splice(this.recents.length);
          this.recents = this.recents.items.concat(resp.data);

          // eslint-disable-next-line 
          //console.log(this.recents
        })
       /* if (Notification.permission == 'granted') {
           new Notification("title", {})
        }*/
      }
    },
    created() {
      /* eslint-disable */
      /*Notification.requestPermission(function (status) {
        console.log('Notification permission status:', status);
      });*/
      this.retrieveData();
      this.timer = setInterval(this.retrieveData, 60000);
      // Set the date we're counting down to


    },

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .layout {
    color: white;
  }


  .section {
    max-width: 1000px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 20px auto 0px;
    flex-wrap: wrap
  }

  @media only screen and (min-width: 600px) {
    .section {
      margin: 10px auto 0px;
    }
  }


  .logo-layout {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .logo-container {
    flex: 0 0 auto;
    margin: 10px 0px 0px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    color: white;
    width:100%;
  }


  @media only screen and (min-width: 600px) {
    .logo-container {
      margin: 30px 0px 0px;
    }
  }

  .logo {
    padding: 0px 10px;
    margin: 10px 0px;
    height: 50px;
    max-width:50%;
    

  }

  .logo-challenge {
    font-size: 30px;
    padding: 0px 10px;
    border-left: 1px solid white;
    text-decoration: none;
    color: white;
    max-width:50%;

  }

  @media only screen and (min-width: 600px) {
    .logo-challenge {
      font-size: 40px;
    }
  }

  .container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    min-height: 100vh;
    padding: 0px 0px;
    margin: 0px auto;
    min-width: 50vw;
  }

  .title-container {
    margin: 0px 10px 20px;
    padding: 20px 0px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-top: 3px solid white;
    border-bottom: 3px solid white;

  }

  @media only screen and (min-width: 600px) {
    .title-container {
      margin: 30px 40px 30px 40px;
    }
  }




  .metric-section {
    max-width: 1200px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    margin: 0px auto;
    flex-wrap: wrap;

  }

  .metric-countdown {
    margin: 20px 0px 0px;

    flex: 0 0 auto
  }

  @media only screen and (min-width: 600px) {

    .metric-countdown {
      margin: 20px 0px;
    }
  }

  .metric-punchcount {
    margin: 0px 0px 0px;
    flex: 1 1 700px;
  }

  @media only screen and (min-width: 600px) {

    .metric-punchcount {
      margin: 20px 0px;
    }
  }




  .info-container {
    position: relative;
    max-width: 1200px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    margin: 20px auto;
    flex-wrap: wrap;
    height: 100%;
    align-items: stretch;

  }

  .info-block {
    position: relative;
    flex: 1 1 auto;

    margin: 10px 0px;
    padding: 20px 10px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: auto;

  }

  .info-logo {
    height: 18px;
    margin: 0px 5px;
  }

  .info-text {

    flex: 1 1 auto;
    max-width: 500px;
    line-height: 1.5;
    font-size: 14px;
  }


  @media only screen and (min-width: 600px) {
    .info-text {
      font-size: 16px;
    }
  }


  .title1 {
    margin: 0px 0px 0px;
    font-size: 40px;
  }

  .title2 {
    margin: 10px 0px;
    font-size: 20px;
  }

  .title3 {
    margin: 0px 0px 0px;
    font-size: 80px;
  }

  @media only screen and (min-width: 600px) {
    .title {
      font-size: 40px;
    }
  }

  @media only screen and (min-width: 800px) {
    .title {
      font-size: 50px;
    }
  }

  @media only screen and (min-width: 1000px) {
    .title {
      font-size: 60px;
    }
  }

  @media only screen and (min-width: 1200px) {
    .title {
      font-size: 80px;
    }
  }

  .text {
    max-width: 500px;
    line-height: 1.5;
    font-size: 14px;
  }

  @media only screen and (min-width: 600px) {
    .text {
      font-size: 16px;
    }
  }

  @media only screen and (min-width: 1000px) {
    .text {
      font-size: 16px;
    }
  }

  .button {
    border: 2px solid white;
    border-radius: 500px;
    padding: 8px 20px;
    margin: 10px;
    font-family: 'ProximaNova-Bold', 'Avenir', Helvetica, Arial, sans-serif;
    cursor: pointer;
    text-decoration: none;
    color: white;
  }

  .link {
    cursor: pointer;
    color: white;

    text-decoration: underline;
    margin: 0px 5px;
  }

  .copyright {
    font-size: 12px
  }
</style>